// @core/api/endpoints/tenant/complete_tenant_onboarding.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CompleteTenantOnboardingRequest,
  TenantOnboardingResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Mark tenant onboarding as complete
 * Explicitly marks the onboarding as complete. Validates that all required steps are done. Triggers product provisioning and initial setup workflows.
 */
export async function CompleteTenantOnboarding(
  tenant_id: string,
  data: CompleteTenantOnboardingRequest,
  options?: RequestOptions
): Promise<TenantOnboardingResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/onboarding/complete`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.post<TenantOnboardingResponse>(requestPath, data, requestOptions);
}
